<template>
  <v-row class="d-flex flex-row align-center justify-center">
    <v-col cols="12" :md="!achievementLevel.subunits.length ? 10 : 12">
      <v-text-field
          class="rounded-lg"
          :label="'Name: ' + achievementLevel.name"
          v-model="name"
          outlined
          label="Название"
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" md="2" v-if="!achievementLevel.subunits.length">
      <v-text-field
          :label="'Score: ' + achievementLevel.score"
          v-model="score"
          outlined
          class="rounded-lg"
          type="number"
          step="0.5"
          @mouseup="focusInput"
          @blur="blurInput"
          label="Баллы"
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import {mapMutations} from "vuex";
import fieldAchievementFocusMixins from "../../mixins/fieldAchievementFocusMixins";

export default {
  name: "AchievementKindLevelTextField",
  mixins: [fieldAchievementFocusMixins],
  props: {
    achievementLevel: Object,
    index: Number
  },
  data() {
    return {
      name: this.achievementLevel.name,
      score: this.achievementLevel.score
    }
  },
  watch: {
    name(newValue) {
      this.updateAchievement()
    },
    score(newValue) {
      this.updateAchievement()
    }
  },
  methods: {
    ...mapMutations({
      updateAchievementLevel: 'achievement_kind/updateAchievementLevel',
    }),
    updateAchievement() {
      this.updateAchievementLevel({
        index: this.index,
        name: this.name,
        score: this.score
      })
    }
  }
}
</script>

<style scoped>


</style>